import type { ReactNode } from "react";
import React from "react";
import { cn } from "@rosette/ts/src/util/cn.js";
import homeBackgroundImg from "@rosette/assets/src/backgrounds/home.png";


interface HomeBackgroundProps {
    className?: string;
    children?: ReactNode;
    fullscreen?: boolean;
}


export function HomeBackground({ className, children, fullscreen }: HomeBackgroundProps) {
    return (
        <section className={cn(
            "relative w-full [:where(&)_:where(h1,h2)]:[text-shadow:0_0.05em_0.1em_rgba(0,0,0,0.25)]",
            fullscreen ? "min-h-screen" : null,
            className ?? null,
        )}>
            <div
                className="pointer-events-none absolute top-0 left-0 -z-100 size-full bg-header bg-size-[16rem] bg-repeat"
                style={{ backgroundImage: `url(${homeBackgroundImg.src})` }} />

            {children}
        </section>
    );
}
